module.exports = __webpack_public_path__ + "static/skyrider-greatsword-defb356389b304f19d7986429b010988.png";